module.exports = __webpack_public_path__ + "static/media/d1p.f16e6571.jpg";